<template>
  <v-card class="profileCard">
    <v-card-text>
      <v-card-title>
        My profile
      </v-card-title>
      <p class="name">{{ user.name }}</p>
      <p>
        <v-btn :to="`/users/${user.sub}`">Me</v-btn>
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    computed: mapState('auth', ['user'])
  };
</script>

<style lang="less" scoped>
  .profileCard {

    .name {
      text-align: left;
      margin-left: 15px;
    }

    p {
      margin: 0;
    }
  }
</style>
